import axios from "axios";

export default async function getFilesExplorer(projectName) {
    const res = await axios.get(`/project/${projectName}/files-explorer`)
    return res;
}